<template>
    <div class="Industryknowledge">
        <div class="header">
            <el-input v-model="searchValue" placeholder="请输入节点或关系搜索" style="width: 350px;margin-right:20px;"></el-input>
            <el-button type="primary" @click="searchNode">搜索</el-button>
        </div>
        <div class="Main">
            <div class="leftcontent itemcon">
                <el-tabs v-model="activeName">
                    <el-tab-pane label="节点类型" name="first">
                        <span class="ADDnode" @click="$router.push('AddNode')"><i class="el-icon-circle-plus-outline"></i>添加节点</span>
                        <el-tree :data="NodeTypeList" node-key="nodeName" :props="defaultProps">
                            <div class="custom-tree-node" slot-scope="{ node, data }">
                                <div class="item" @click="handleNodeClick(data)">{{ data.nodeName}}</div>
                                <div class="item" v-if="data.id || data.id==0">
                                  <label @click="$router.push('AddNode?iscopy=1&id='+data.id+'&type='+data.type)">拷贝</label>
                                  <label @click="$router.push('AddNode?iscopy=0&id='+data.id+'&type='+data.type)">编辑</label>
                                  <el-popconfirm title="是否确认删除？" @confirm="DeleteNode(data)">
                                    <label slot="reference">删除</label>
                                  </el-popconfirm>
                                </div>
                            </div>
                        </el-tree>
                    </el-tab-pane>
                    <el-tab-pane label="关系类型" name="second">
                        <span class="ADDnode" @click="$router.push('AddRelationship')"><i class="el-icon-circle-plus-outline"></i>添加关系</span>
                        <el-tree :data="UserList" :props="defaultProps">
                          <div class="custom-tree-node" slot-scope="{ node, data }" node-key="nodeName" >
                                <div class="item" v-if="data.type=='first'" @click="handleRelationshipClick(data)">{{ data.nodeName}}</div>
                                <template v-if="data.id || data.id==0">
                                  <div class="item">{{ data.startNode.nodeName}} -> {{ data.endNode.nodeName}}</div>
                                  <div class="item">
                                    <label @click="$router.push('AddRelationship?iscopy=1&id='+data.id+'&type='+data.relationshipType)">拷贝</label>
                                    <label @click="$router.push('AddRelationship?iscopy=0&id='+data.id+'&type='+data.relationshipType)">编辑</label>
                                    <el-popconfirm title="是否确认删除？" @confirm="DeleteRelationship(data)">
                                      <label slot="reference">删除</label>
                                    </el-popconfirm>
                                  </div>
                                </template>
                            </div>
                        </el-tree>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div class="itemcon rightcontent">
              <!-- <el-row style="text-align: center;">
                <el-col :span="1"><el-button>+</el-button></el-col>
                <el-col :span="3"><el-input style="text-align: center;" type="text" v-model="num"></el-input></el-col>
                <el-col :span="1"><el-button>-</el-button></el-col>
              </el-row> -->
              <div id="myChart" style="width:100%;height:100%;"></div>
            </div>
            
        </div>
        
    </div>
</template>
<script>
export default{
    data() {
        return {
            searchValue:'',
            activeName:'first',
            num:'100%',
            showname:true,
            AllGraph:'',
            NodeTypeList:[],
            UserList:[],
            defaultProps: {
            children: 'children',
            label: 'label'
            },
        }
    },
    watch:{
      activeName(newval,oldval){
        if(newval=='first'){
          this.getNodeTypeList();
        }else{
          this.getAllRelationshipType();
        }
      }
    },
    created() {
      this.getNodeTypeList();
      this.getAllGraph();
    },
    methods: {
      // 获取节点类型
      getNodeTypeList(){
          this.NodeTypeList=[];
            this.$Http_Post('node/getNodeTypeList',{model:'industry'}).then(res=>{
                if(res.Code==0){
                    for(let item in res.Data){
                      this.NodeTypeList.push({nodeName:res.Data[item],children:[],type:'first',index:item})
                    }
                }
            })
        },
        //点击节点
        handleNodeClick(val){
          if(val.type=='first'){
            this.$Http_Post('node/getNodeListByType',{type:val.nodeName,pageNum:1,pageSize:10,model:'industry'}).then(res=>{
              if(res.Code==0){
                this.NodeTypeList[val.index].children=res.Data;
              }else{
                this.$message({type: 'error', message:res.Message});
              }
            });
          }else{
            this.getGraphByNodeIdAdnType(val,val.type);
          }
        },

        // 关系点击节点
        handleRelationshipClick(val){
          if(val.type=='first'){
            this.$Http_Post('relationship/getRelationshipByType',{type:val.nodeName,pageNum:1,pageSize:10,model:'industry'}).then(res=>{
              if(res.Code==0){
                this.UserList[val.index].children=res.Data;
              }else{
                this.$message({type: 'error', message:res.Message});
              }
            });
          }else{
            this.getGraphByNodeIdAdnType(val,val.relationshipType);
          }
        },

        // 获取关系类型
        getAllRelationshipType(){
          this.$Http_Post('relationship/getAllRelationshipType',{model:'industry'}).then(res=>{
            this.UserList=[];
              if(res.Code==0){
                  for(let item in res.Data){
                    this.UserList.push({nodeName:res.Data[item],children:[],type:'first',index:item})
                  }
              } 
          })
        },

      // 获取全部图谱信息
      getAllGraph(){
        this.$Http_Post('node/getAllGraph',{model:'industry'}).then(res=>{
          if(res.Code==0){
            this.AllGraph=res.Data;
            this.init(true);
          }else{
            this.$message({type: 'error', message:res.Message});
          }
        })
      },
      // 根据节点名查询节点
      searchNode(){
        this.$Http_Post('node/getGraphBySearchValue',{searchValue:this.searchValue,model:'industry'}).then(res=>{
          if(res.Code==0){
            this.AllGraph=res.Data;
            this.init(true);
          }else{
            this.$message({type: 'error', message:res.Message});
          }
        })
      },
      // 根据节点id和类型获取图谱数据
      getGraphByNodeIdAdnType(val,type){
        this.$Http_Post('node/getGraphByNodeIdAdnType',{nodeId:val.id,type:type,model:'industry'}).then(res=>{
          if(res.Code==0){
            this.AllGraph=res.Data;
            this.init(true);
          }else{
            this.$message({type: 'error', message:res.Message});
          }
        })
      },

      // 删除节点
      DeleteNode(val){
          this.$Http_Post('node/deleteNode',{nodeId:val.id,type:val.type,model:'industry'}).then(res=>{
            if(res.Code==0){
              this.$message({type: 'success', message:res.Message});
              this.getNodeTypeList();
            }else{
              this.$message({type: 'error', message:res.Message})   
            }
          });
        },
        // 删除关系
        DeleteRelationship(val){
          this.$Http_Post('relationship/deleteRelationship',{id:'',startNodeId:'',startNodeType:'',endNodeId:'',endNodeType:'',relationshipType:''}).then(res=>{
            if(res.Code==0){
              this.$message({type: 'success', message:res.Message});
              this.getAllRelationshipType();
            }else{
              this.$message({type: 'error', message:res.Message})  
            }
          });
        },
        init(showname){
            let myChart = this.$echarts.init(document.getElementById('myChart'));
            myChart.setOption({
              tooltip: {
                  width: '200px',
                  formatter:function(params){
                    let content='';
                    if(params.dataType =='node'){
                      let html="名称:"+params.data.nodeName+'<br/>描述：'+params.data.nodeDescription+'<br/>';
                      if(params.data.otherAttr && params.data.otherAttr.length>0){
                        for(let item of params.data.otherAttr){
                          content=item.attrName+' '+item.attrValue;
                          html+=content
                        }
                      }
                      return html;
                    }else{
                      let html="关系:"+params.data.relationshipType+'<br/>描述：'+params.data.relationshipDescription+'<br/>';
                      if(params.data.otherAttr && params.data.otherAttr.length>0){
                        for(let item of params.data.otherAttr){
                          content=item.attrName+' '+item.attrValue;
                          html+=content
                        }
                      }
                      return html;
                    }
                    
                  }
                },
                series: [
                  {
                      type: 'graph',
                      layout: 'none',
                      data: this.AllGraph.nodes,
                      links: this.AllGraph.links,//线之间的关系
                      categories: this.AllGraph.categories,
                      color:['#fc853e','#28cad8','#9564bf','#bd407e','#28cad8','#e5a214',],//配置线条及原点的颜色
                      roam: true,//是否可拖动
                      focusNodeAdjacency: true,
                      force: {
                        initLayout: "circular",
                        repulsion: 2500, // 节点斥力
                        gravity: 0.5, // 所有节点受到的向中心的引力因子。该值越大节点越往中心点靠拢。
                        layoutAnimation: false, // 节点动画
                      },
                      label: {
                          show: showname,//是否显示节点的名字
                          position: 'bottom',//文字显示的位置
                          formatter:function(params){
                            return params.data.nodeName;
                          }
                      },
                      scaleLimit: {min: 0.6,max:2,},//缩放比例
                      lineStyle: {color: 'source',curveness: 0.3,},//线条样式
                      emphasis: {
                        focus: 'adjacency',
                        lineStyle: {
                          width: 1.5
                        },
                        label: {
                          formatter: function(params) {
                              return params.data.nodeName;
                          }
                        }
                      }
                  }
                ]
            })
        },

        
    },
}
</script>
<style>
.Industryknowledge .header{background: #fff;padding:20px;}
.Industryknowledge .Main{background: #fff;display: flex;}
.Industryknowledge .Main .itemcon{display: inline-block;height:auto;}
.Industryknowledge .Main .rightcontent{flex: 1;height:70vh;}
.Industryknowledge .leftcontent{width:450px;border-right: 1px solid #d3d3d3;padding: 0 20px;}
.Industryknowledge .custom-tree-node{display: flex;justify-content: space-between;width:100%;}
.Industryknowledge .custom-tree-node .item{display: inline-block;}
.Industryknowledge .custom-tree-node .item label{background: #409EFF;color: #fff;padding: 2px 5px;margin: 0 5px;border-radius: 4px;}
.Industryknowledge .ADDnode{padding:0 20px;color: #6d6d6d;}
/* .rightcontent .el-input__inner{text-align: center!important;;} */
.Industryknowledge #myChart>div:nth-child(2){width:400px!important;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;}
</style>